/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlightLookupResult
 */
export interface FlightLookupResult {
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    departureIata: string;
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    arrivalIata: string;
    /**
     * 
     * @type {Date}
     * @memberof FlightLookupResult
     */
    departureDatetime: Date;
    /**
     * 
     * @type {Date}
     * @memberof FlightLookupResult
     */
    arrivalDatetime: Date;
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    flightNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    airlineIata: string;
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    airlineName: string;
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    aircraftType?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightLookupResult
     */
    status?: string;
}

/**
 * Check if a given object implements the FlightLookupResult interface.
 */
export function instanceOfFlightLookupResult(value: object): value is FlightLookupResult {
    if (!('departureIata' in value) || value['departureIata'] === undefined) return false;
    if (!('arrivalIata' in value) || value['arrivalIata'] === undefined) return false;
    if (!('departureDatetime' in value) || value['departureDatetime'] === undefined) return false;
    if (!('arrivalDatetime' in value) || value['arrivalDatetime'] === undefined) return false;
    if (!('flightNumber' in value) || value['flightNumber'] === undefined) return false;
    if (!('airlineIata' in value) || value['airlineIata'] === undefined) return false;
    if (!('airlineName' in value) || value['airlineName'] === undefined) return false;
    return true;
}

export function FlightLookupResultFromJSON(json: any): FlightLookupResult {
    return FlightLookupResultFromJSONTyped(json, false);
}

export function FlightLookupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightLookupResult {
    if (json == null) {
        return json;
    }
    return {
        
        'departureIata': json['departure_iata'],
        'arrivalIata': json['arrival_iata'],
        'departureDatetime': (new Date(json['departure_datetime'])),
        'arrivalDatetime': (new Date(json['arrival_datetime'])),
        'flightNumber': json['flight_number'],
        'airlineIata': json['airline_iata'],
        'airlineName': json['airline_name'],
        'aircraftType': json['aircraft_type'] == null ? undefined : json['aircraft_type'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function FlightLookupResultToJSON(json: any): FlightLookupResult {
    return FlightLookupResultToJSONTyped(json, false);
}

export function FlightLookupResultToJSONTyped(value?: FlightLookupResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'departure_iata': value['departureIata'],
        'arrival_iata': value['arrivalIata'],
        'departure_datetime': value['departureDatetime'].toISOString(),
        'arrival_datetime': value['arrivalDatetime'].toISOString(),
        'flight_number': value['flightNumber'],
        'airline_iata': value['airlineIata'],
        'airline_name': value['airlineName'],
        'aircraft_type': value['aircraftType'],
        'status': value['status'],
    };
}

